import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class Globals{
  public  VAR1 = 'value1';
    public VAR2 = 'value2';
    private baseAmount = 750;

    public formatDate(dtp){
        if(dtp!=''){
          const dtpnew = moment(dtp).format("YYYY-MM-DD").toString();
           return dtpnew;
        }else{
          return dtp;
        }
      }
    
    public  numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
        }
        return true;
      }

     public computeAmount(frequency: number){
        let tAmount = 0;
        if(frequency==1){
           return '' +  (this.baseAmount * 1);
        }
        else if(frequency == 3){
         return '' +  (this.baseAmount * 3);
        }
        else if(frequency == 4){
         return '' +  (this.baseAmount * 6);
        }
        else if(frequency == 5){
         return '' +  (this.baseAmount * 12);
        }
   }
    
}
